// Mock contact data for local-dev / preview builds. The dev fallback path in
// api/client.ts uses these when the worker isn't reachable. Mailing_State
// values intentionally include the messy free-text variants from Q3b so the
// normaliser is exercised in the preview.

import type { ZohoContact } from '@deltasuite/zoho-client';

const MOCK: readonly Omit<ZohoContact, 'Account_Name'>[] = [
  {
    id: '1',
    First_Name: 'Lara',
    Last_Name: 'Henderson',
    Email: 'lara@plumarchitects.com.au',
    Mobile: '0412 555 901',
    Title: 'Senior Architect',
    Mailing_State: 'NSW',
    Company_Type: 'Architect',
    Last_Activity_Time: '2026-04-22T03:14:00Z',
  },
  {
    id: '2',
    First_Name: 'Tom',
    Last_Name: 'Kerridge',
    Phone: '08 9000 1234',
    Title: 'Director',
    Mailing_State: 'Western Australia',
    Company_Type: 'Specifier',
    Last_Activity_Time: '2026-03-02T08:00:00Z',
  },
  {
    id: '3',
    First_Name: 'Sasha',
    Last_Name: 'Patel',
    Email: 'sasha@buildright.com',
    Mobile: '0411 222 333',
    Title: 'Site Manager',
    Mailing_State: 'WA',
    Company_Type: 'Builder - Commercial',
    Last_Activity_Time: '2026-04-28T22:30:00Z',
  },
  {
    id: '4',
    First_Name: 'Marcus',
    Last_Name: 'Liang',
    Mobile: '0433 444 555',
    Title: 'Owner',
    Mailing_State: 'vic',
    Company_Type: 'Cabinetmaker',
  },
  {
    id: '5',
    First_Name: 'Jen',
    Last_Name: 'O’Connor',
    Email: 'jen@cooradesign.com',
    Title: 'Principal',
    Mailing_State: 'NSW',
    Company_Type: 'Commercial Interiors',
    Last_Activity_Time: '2025-11-19T01:00:00Z',
  },
  {
    id: '6',
    First_Name: 'Andy',
    Last_Name: 'Voss',
    Mobile: '0421 999 000',
    Mailing_State: 'Q.L.D.',
    Company_Type: 'Builder',
    Last_Activity_Time: '2026-04-15T07:00:00Z',
  },
  {
    id: '7',
    First_Name: 'Priya',
    Last_Name: 'Bhat',
    Email: 'priya@parkerblack.com.au',
    Mobile: '0417 222 111',
    Title: 'Specifier',
    Mailing_State: 'Victoria',
    Company_Type: 'Architect',
    Last_Activity_Time: '2026-02-08T11:00:00Z',
  },
  {
    id: '8',
    First_Name: 'Brett',
    Last_Name: 'Salomon',
    Phone: '03 9000 4321',
    Mailing_State: 'VIC',
    Company_Type: 'Reseller - Commercial',
    Last_Activity_Time: '2026-04-29T01:00:00Z',
  },
  {
    id: '9',
    First_Name: 'Emma',
    Last_Name: 'Tully',
    Mobile: '0488 777 666',
    Title: 'Project Manager',
    Mailing_State: 'SA',
    Company_Type: 'Project Manager',
    Last_Activity_Time: '2026-01-10T08:00:00Z',
  },
  {
    id: '10',
    First_Name: 'Sam',
    Last_Name: 'Whitford',
    Email: 'sam@whitfordcab.com',
    Mailing_State: 'wa',
    Company_Type: 'Cabinet',
    Last_Activity_Time: '2026-04-23T02:00:00Z',
  },
  {
    id: '11',
    First_Name: 'Floyd',
    Last_Name: 'Mitchell',
    Mobile: '0431 654 321',
    Mailing_State: 'South Australia',
    Company_Type: 'Door Shop',
    Last_Activity_Time: '2026-04-30T01:00:00Z',
  },
  {
    id: '12',
    First_Name: 'Helen',
    Last_Name: 'McGrath',
    Email: 'helen@mcgratharch.com',
    Title: 'Architect',
    Mailing_State: 'ACT',
    Company_Type: 'Architect',
    Last_Activity_Time: '2025-09-04T05:00:00Z',
  },
  {
    id: '13',
    First_Name: 'Kostas',
    Last_Name: 'Pappas',
    Mobile: '0455 333 222',
    Mailing_State: 'NSW',
    Company_Type: 'Reseller',
    Last_Activity_Time: '2026-04-26T08:00:00Z',
  },
  {
    id: '14',
    First_Name: 'Anita',
    Last_Name: 'Russo',
    Email: 'anita@russojoinery.com',
    Title: 'Owner',
    Mailing_State: 'VIC',
    Company_Type: 'Joinery',
  },
  {
    id: '15',
    First_Name: 'Jules',
    Last_Name: 'Khoury',
    Mobile: '0466 111 222',
    Title: 'Builder',
    Mailing_State: 'New South Wales',
    Company_Type: 'Builder - Residential',
    Last_Activity_Time: '2026-04-12T04:00:00Z',
  },
  {
    id: '16',
    First_Name: 'Wendy',
    Last_Name: 'Frasier',
    Email: 'wendy@frasierwindows.com',
    Mailing_State: 'TAS',
    Company_Type: 'Window & Doors',
    Last_Activity_Time: '2026-03-18T03:00:00Z',
  },
  {
    id: '17',
    First_Name: 'Rohan',
    Last_Name: 'Shastri',
    Mobile: '0408 555 444',
    Mailing_State: 'NSW',
    Company_Type: 'Specifier',
    Last_Activity_Time: '2026-04-27T09:00:00Z',
  },
  {
    id: '18',
    First_Name: 'Greg',
    Last_Name: 'Bartholomew',
    Phone: '02 8000 9999',
    Mailing_State: 'Q L D',
    Company_Type: 'Builder - Modular',
  },
  {
    id: '19',
    First_Name: 'Maya',
    Last_Name: 'Doyle',
    Mobile: '0413 800 777',
    Title: 'Designer',
    Mailing_State: 'NT',
    Company_Type: 'Commercial Interiors',
    Last_Activity_Time: '2026-02-22T00:00:00Z',
  },
  {
    id: '20',
    First_Name: 'Vincent',
    Last_Name: 'Aprile',
    Email: 'vincent@aprilecabinets.com',
    Mailing_State: 'VIC',
    Company_Type: 'Cabinetmaker Supplie',
    Last_Activity_Time: '2026-04-08T01:00:00Z',
  },
];

export const MOCK_CONTACTS: readonly ZohoContact[] = MOCK.map((c) => ({
  ...c,
  Account_Name: { id: `co-${c.id}`, name: `${c.Last_Name} & Co.` },
}));
